import React, { useEffect } from 'react'
import './Regularpayment.css'
import { formatDate, setActivity, useFetchAccountDetail, getdata } from '../../Global/Index';
import ClipLoader from 'react-spinners/ClipLoader';
import { ToastContainer, toast } from 'react-toastify';
import { PiSealCheckLight } from "react-icons/pi";
import { useTheme } from '@mui/material';



const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: '50%'
};


const RegularPaymentMode = () => {
    const theme = useTheme();

    useEffect(() => {
        const getdatafunction = async () => {
            const data = await getdata();
            if (data.response.status === "503") {
                toast.warn(data.response.message);
            } else if (data.response.status === "419") {
                window.location.href = '/Session-Expired';
            } else if (data.response.status === "401") {
                window.location.href = '/';
            } else if (data.response.status === "500") {
                toast.error('Something went wrong. Please try again later!');
            }
        }
        getdatafunction()
        setActivity('Regular Payment Mode Page');
    }, [])


    const { data: FetchAccountDetailData, isLoading: isLoadingFetchAccountDetail, error: FetchAccountDetailError } = useFetchAccountDetail();
    const isLoading = isLoadingFetchAccountDetail || FetchAccountDetailError;

    if (FetchAccountDetailData) {
        if (FetchAccountDetailData?.response?.status == "500") {
            toast.error('something went wrong. Please try again later!')
        }
    }

    let mandatedata = FetchAccountDetailData?.response?.data ?? null;
    const isAchNotRegistered = mandatedata && Object.values(mandatedata).every((value) => !value);


    const handleRedirect = () => {
        localStorage.setItem('activeLinkId', "5");
        localStorage.setItem('ActiveService', "1");
        window.location.href = '/success/All-Service-Request';
    };

    const renderContent = () => {
        if (!mandatedata) return null;
        if (isAchNotRegistered) {
            return (
                <div>
                    <p className='smsinst'>Your ACH is not registered. Kindly register by following the given steps :-<br /></p>
                    <span>Service Request -&gt; ALL Service Request -&gt; Create E-Mandate to register your ACH.</span> <br />
                    <button
                        style={{ color: 'blue', textDecoration: 'underline', background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize:'15px' }}
                        onClick={handleRedirect}
                    >
                        Redirect Me
                    </button>
                </div>
            );
        }

        return (
            <div className='paymentmodeflex'>
                {renderMandateDetails()}
            </div>
        );
    };

    const renderMandateDetails = () => (
        <>
            <div>
                <div className='distance1'>
                    <p className="marginright">Bank Name</p>
                    <h4>{mandatedata?.branchName || "NA"}</h4>
                </div>
                <div className='distance1'>
                    <p className="marginright">UMRN</p>
                    <h4>{mandatedata?.umrn || "NA"}</h4>
                </div>
            </div>
            <div>
                <div className='distance1'>
                    <p className="marginright">Account Number</p>
                    <h4>{mandatedata?.accountNumber || "NA"}</h4>
                </div>
            </div>
            <div>
                <div className='distance1'>
                    <p className="marginright">Auto Debit Date</p>
                    <h4>{mandatedata?.autoDebitDate ? formatDate(mandatedata?.autoDebitDate) : "NA"}</h4>
                </div>
            </div>

        </>
    );



    return (
        <>
            <ToastContainer />
            <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                <h2>Regular Payment Modes</h2>
                <div className="mainsubcontainer">
                    <div className='Paymentmode'>
                        <div style={{ marginBottom: '1vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <b>Automated Clearing House (ACH)</b>
                            {mandatedata && !isAchNotRegistered && (
                                <b style={{ color: 'darkgreen', marginRight: '5%', display: 'flex', alignItems: 'center', gap: '1vh' }}>
                                    Active <PiSealCheckLight style={{ fontSize: '20px' }} />
                                </b>
                            )}
                        </div>
                        {isLoading? (
                            <ClipLoader
                                color={theme.palette.maincolor.light}
                                loading={true}
                                cssOverride={override}
                                size={30}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        ) : (
                            renderContent()
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
export default RegularPaymentMode
